import "./css/IIITHUserJourney.css";
export const IIITHUserJourney = () => {
  return (
    <div style={{ width: "100%" }} className="intern-bg">
      <div
        style={{
          padding: "10px 10px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "80vw",
            marginTop: "20px",
            borderRadius: "20px",
          }}
        >
          <p className="heading-text-3">Your User Journey</p>
          <div className="user-journey-section"></div>
        </div>
      </div>
    </div>
  );
};
